import { atom } from 'jotai';

/**
 * Whether the work-card QR scanner overlay is open.
 *
 * The scanner flow is mounted once in the app layout so that both the header button and the
 * "Κάρτα Εργασίας" page can open it from anywhere in the app.
 */
export const isWorkCardScannerOpenAtom = atom<boolean>(false);
